(function () {
  function ready() {
    var progressPath = document.querySelector('.button__back-to-top .progress-circle path');
    if (!progressPath) return;

    var pathLength;
    var lastProgress;
    var frame = null;

    function updateProgress() {
      frame = null;
      var scroll = window.scrollY || window.pageYOffset || 0;
      // The control is hidden at the top. Initialize its SVG only when needed.
      if (pathLength === undefined) {
        if (scroll <= 0) return;
        pathLength = progressPath.getTotalLength();
        progressPath.style.transition = 'none';
        progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
      }
      var height = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var fraction = Math.max(0, Math.min(1, scroll / height));
      var progress = pathLength * (1 - fraction);
      if (lastProgress !== progress) {
        progressPath.style.strokeDashoffset = progress;
        lastProgress = progress;
      }
    }

    function scheduleUpdate() {
      if (frame === null) frame = window.requestAnimationFrame(updateProgress);
    }

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('load', scheduleUpdate, { once: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(scheduleUpdate).observe(document.body);
    }
    if (window.scrollY || window.pageYOffset) scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
}());
